import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';

import TaskChangeStatusManageModal from 'components/Tasks/_actions/TaskChangeStatusManageModal';
import UserBanManageModal from 'components/Users/_actions/UserBanManageModal';
import { selectConcatRoles } from 'mt-react-common/modules/users/common/reducers/states/authAccount';

const ManageBlock = props => {
  const { taskModel, onRefreshParentContent } = props;
  const [
    isOpenTaskChangeStatusManageModal,
    setIsOpenTaskChangeStatusManageModal
  ] = useState(false);
  const [isOpenUserBanManageModal, setIsOpenUserBanManageModal] = useState(
    false
  );
  const concatRoles = useSelector(state => selectConcatRoles(state));

  return (
    <React.Fragment>
      {concatRoles !== '' ? (
        <React.Fragment>
          <TaskChangeStatusManageModal
            isOpen={isOpenTaskChangeStatusManageModal}
            onClose={() => setIsOpenTaskChangeStatusManageModal(false)}
            modalIndex={taskModel.id}
            taskModel={taskModel}
            onRefreshParentContent={onRefreshParentContent}
          />
          <UserBanManageModal
            isOpen={isOpenUserBanManageModal}
            onClose={() => setIsOpenUserBanManageModal(false)}
            modalIndex={taskModel.id}
            userId={taskModel.owner.id}
            onRefreshParentContent={onRefreshParentContent}
          />
          <button
            className="btn btn-danger btn-sm"
            data-toggle="tooltip"
            type="button"
            title={t('Заблокировать задание')}
            onClick={() => setIsOpenTaskChangeStatusManageModal(true)}
          >
            <i className={`fa fa-ban`} />
          </button>
          <button
            className="btn btn-danger btn-sm"
            data-toggle="tooltip"
            type="button"
            title={t('Заблокировать заказчика')}
            onClick={() => setIsOpenUserBanManageModal(true)}
          >
            <i className={`fa fa-user-times`} />
          </button>
        </React.Fragment>
      ) : null}
    </React.Fragment>
  );
};

ManageBlock.defaultProps = {
  onRefreshParentContent: () => {}
};

ManageBlock.propTypes = {
  taskModel: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    owner: PropTypes.shape({
      id: PropTypes.number
    })
  }).isRequired,
  onRefreshParentContent: PropTypes.func
};

export default ManageBlock;



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksToExecutorsList/TasksToExecutorsListItem/ManageBlock/index.js